import {IRangeValue} from "../../api/InFormReportingApi";
import * as React from "react";

export const renderData = (data: any) => {
    if (data) {
        return Object.keys(data!)
            .map((key) => {
                if (!Array.isArray(data[key])) {
                    return <div key={key}><h5>{key} : <i>{data[key]}</i></h5></div>;
                } else {
                    const dataArray: [any] = data[key];
                    return <div key={key}>
                        <h5>{key} : [ </h5>
                    <div style={{paddingLeft: '50px'}}>
                    {dataArray.map((it) => renderRangeValue(it))}
                    </div>
                    <h5>]</h5>
                    </div>;
                }
            });
    }
    return null;
};

const renderRangeValue = (data: IRangeValue) => {
    if (data) {
        return <div><h5>value: {data.value},&emsp;date: {data.date.toString()}</h5></div>;
    }
    return null;
};